import axios from 'axios';
import BigNumber from 'bignumber.js';
import { KattanaAPI } from '../store/createStore';
import { NATIVE_LINK } from '../wallet/hooks/useLoadWalletData';

type FetchBalanceArgs = {
  address: string;
  token: string;
};

const tokenBalanceUrl = (address: string, token: string) =>
  `https://api.multiversx.com/accounts/${address}/tokens/${token}`;

export async function fetchElrondBalance({ address, token }: FetchBalanceArgs) {
  try {
    if (!token) {
      const balance = await KattanaAPI.tokenBalanceForWallet(
        'ELROND',
        NATIVE_LINK,
        address
      );

      if (balance) {
        return BigNumber(balance).div(10 ** 18);
      } else {
        return BigNumber(0);
      }
    }
    const resp = await axios.get(tokenBalanceUrl(address, token));
    if (resp.status === 200) {
      return BigNumber(resp.data.balance).div(10 ** resp.data.decimals);
    } else {
      return BigNumber(0);
    }
  } catch (error) {
    console.log(error);
    return BigNumber(0);
  }
}
